module.exports = __webpack_public_path__ + "img/girl.540fb1fe.png";